import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Form, Formik } from "formik";
import { navigate } from "gatsby-link";
import { useI18next } from "gatsby-plugin-react-i18next";
import React, { useEffect, useState } from "react";
import Countdown from "react-countdown";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import ErrorBox from "../../../../blue-library/components/errorBox";
import InputOTP from "../../../../blue-library/elements/inputOTP";
import PopupMsg from "../../../../blue-library/elements/popupMsg";
import { getCustomerPrefillInfo } from "../../../../corporate-site/api/quotation";
import { activeAccountSource } from "../../../../pages/active-acc-next";
import { forgetPasswordSource } from "../../../../pages/forget-pw-next";
import { pushDataLayer } from "../../../../shared/context/gtm-manager";
import { loadTencentCaptcha } from "../../../../shared/utils/tencent_captcha";
import { fetchLoginState } from "../../../../store/qnbProductSlice";
import { setPersonalInfo } from "../../../../store/siteSlice";
import { resendSMSOTP, verifyOtp, sendSMSOTP } from "../../../api/login";
import { getGaContentGroup, getGaStep } from "../../../gtmConverter";
import SubmitButton from "../../submitButton";
import { AlertErrorBottomContact } from "../Message/CustomErrorTailing";
var OTP = function OTP(_ref) {
    var onSubmit = _ref.onSubmit, extErrorCode = _ref.extErrorCode, afterSubmitRedirect = _ref.afterSubmitRedirect, source = _ref.source, apiType = _ref.apiType;
    var dispatch = useDispatch();
    var _useState = useState(0), retryCounter = _useState[0], setRetryCounter = _useState[1];
    var setOpen = function setOpen(status) { dispatch({ type: "ui/setDialogOpen", payload: { status: status } }); };
    var _useState2 = useState(""), errorCode = _useState2[0], setErrorCode = _useState2[1];
    var _useTranslation = useTranslation(), t = _useTranslation.t;
    var _useSelector = useSelector(function (state) { return state.ui; }), dialogLastPage = _useSelector.dialogLastPage;
    var checkOTPSuccess = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(otpInput) {
            var otpCode, res;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            otpCode = !otpInput ? "" : otpInput === null || otpInput === void 0 ? void 0 : otpInput.join("");
                            _context.next = 3;
                            return verifyOtp({ otpCode: otpCode });
                        case 3:
                            res = _context.sent;
                            if (!res.errorCode && res.result) {
                                dispatch({ type: "ui/login" });
                                dispatch(fetchLoginState("")).then(function (res) {
                                    if (dialogLastPage === "login") {
                                        var _res$payload$userId, _res$payload;
                                        pushDataLayer({ event: "trackEventNoEcommerce", "eventDetails.category": "login", "eventDetails.action": "completed", "eventDetails.label": undefined,
                                            customerIDHit: (_res$payload$userId = (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.userId) !== null && _res$payload$userId !== void 0 ? _res$payload$userId : undefined,
                                            loginStatus: "logged in user" });
                                    }
                                });
                                setOpen(false);
                                afterSubmitRedirect && navigate(afterSubmitRedirect);
                            }
                            else {
                                setErrorCode(res.errorCode);
                            }
                        case 5:
                        case "end": return _context.stop();
                    }
                }
            }, _callee);
        }));
        return function checkOTPSuccess(_x) { return _ref2.apply(this, arguments); };
    }();
    var _useState3 = useState(Date.now() + 60000), time = _useState3[0], setTime = _useState3[1];
    var _useI18next = useI18next(), language = _useI18next.language;
    var loadCaptcha = /*#__PURE__*/ function () { var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() { var data, res; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
        switch (_context2.prev = _context2.next) {
            case 0:
                _context2.next = 2;
                return loadTencentCaptcha(language);
            case 2:
                data = _context2.sent;
                if (!(data && Object.keys(data).length !== 0)) {
                    _context2.next = 17;
                    break;
                }
                if (!apiType) {
                    _context2.next = 10;
                    break;
                }
                _context2.next = 7;
                return sendSMSOTP(data.ticket, data.randstr);
            case 7:
                _context2.t0 = _context2.sent;
                _context2.next = 13;
                break;
            case 10:
                _context2.next = 12;
                return resendSMSOTP(data.ticket, data.randstr);
            case 12: _context2.t0 = _context2.sent;
            case 13:
                res = _context2.t0;
                if (!res.errorCode && res.result) {
                    setTime(Date.now() + 60000);
                    setRetryCounter(retryCounter + 1);
                }
                else {
                    setErrorCode(res.errorCode);
                }
                _context2.next = 18;
                break;
            case 17: setErrorCode("-612");
            case 18:
            case "end": return _context2.stop();
        }
    } }, _callee2); })); return function loadCaptcha() { return _ref3.apply(this, arguments); }; }();
    var shouldDisplayBothChannel = function shouldDisplayBothChannel() { if (!source)
        return true; return ![activeAccountSource, forgetPasswordSource].includes(source); };
    useEffect(function () { var pathname = window.location.pathname == "/" ? "" : window.location.pathname; pushDataLayer({ event: "trackVirtualPageView", page_location: window.location.origin + pathname + "/pop-up/mobile-verification" + window.location.search, page_title: document.title ? document.title : localStorage.getItem("qnbMetaTitle"), page_referrer: window.location.origin + pathname + "/pop-up/login" + window.location.search, customerIDHit: "", loginStatus: "non-logged in user", qnb_step: getGaStep(), content_group: getGaContentGroup(), blog_category: undefined, author: undefined }); }, []);
    return /*#__PURE__*/ React.createElement(PopupMsg, { name: "login", id: "0", alertStyle: "acc", data: "popupMsgData" }, /*#__PURE__*/ React.createElement("div", { className: "flex flex-col items-center space-y-5" }, /*#__PURE__*/ React.createElement("h4", { className: "mb-3" }, t("verifyYourIndentity")), /*#__PURE__*/ React.createElement("p", { className: "px-12" }, shouldDisplayBothChannel() ? t("sendCaptchaMessage") : t("sendCaptchaMessageOnlySms")), /*#__PURE__*/ React.createElement(Formik, { onSubmit: /*#__PURE__*/ function () { var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(values) { var resp, prefillPersonalInfo, _prefillPersonalInfo$, _prefillPersonalInfo$2, personalInfo; return _regeneratorRuntime.wrap(function _callee3$(_context3) { while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    if (!onSubmit) {
                        _context3.next = 5;
                        break;
                    }
                    _context3.next = 3;
                    return onSubmit(values.otp);
                case 3:
                    _context3.next = 7;
                    break;
                case 5:
                    _context3.next = 7;
                    return checkOTPSuccess(values.otp);
                case 7:
                    if (!(source !== forgetPasswordSource)) {
                        _context3.next = 12;
                        break;
                    }
                    _context3.next = 10;
                    return getCustomerPrefillInfo();
                case 10:
                    resp = _context3.sent;
                    if (resp.result && !resp.errorCode) {
                        prefillPersonalInfo = resp.data;
                        if (prefillPersonalInfo && prefillPersonalInfo.gender != null && prefillPersonalInfo.smokeFlag != null) {
                            personalInfo = { sex: (_prefillPersonalInfo$ = prefillPersonalInfo.gender) !== null && _prefillPersonalInfo$ !== void 0 ? _prefillPersonalInfo$ : undefined, smoke: (_prefillPersonalInfo$2 = prefillPersonalInfo.smokeFlag) !== null && _prefillPersonalInfo$2 !== void 0 ? _prefillPersonalInfo$2 : undefined };
                            if (prefillPersonalInfo.age) {
                                personalInfo.age = Number(prefillPersonalInfo.age);
                            }
                            dispatch(setPersonalInfo(personalInfo));
                        }
                    }
                case 12:
                case "end": return _context3.stop();
            }
        } }, _callee3); })); return function (_x2) { return _ref4.apply(this, arguments); }; }(), initialValues: { otp: [] }, validationSchema: yup.object().shape({ otp: yup.array().required(t("OTP.VALIDATION")) }) }, function () { var _ref6; return /*#__PURE__*/ React.createElement(Form, { className: " space-y-5 " }, /*#__PURE__*/ React.createElement("div", { className: "w-full text-left" }, /*#__PURE__*/ React.createElement(InputOTP, { name: "otp" }), /*#__PURE__*/ React.createElement(Countdown, { autoStart: true, key: retryCounter, date: time, renderer: function renderer(props) { return props.completed ? /*#__PURE__*/ React.createElement("p", { className: "text-sm text-corporate-1 cursor-pointer", onClick: /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee4() { return _regeneratorRuntime.wrap(function _callee4$(_context4) { while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return loadCaptcha();
                    case 2:
                    case "end": return _context4.stop();
                }
            } }, _callee4); })) }, t("resendMessageCaptcha")) : /*#__PURE__*/ React.createElement("p", { className: "text-sm text-secondary cursor-default" }, t("resendMessageCaptcha"), " (", props.seconds === 0 ? "60" : "" + props.seconds, "s)"); } })), /*#__PURE__*/ React.createElement(ErrorBox, { errorCode: (_ref6 = onSubmit ? extErrorCode : errorCode) !== null && _ref6 !== void 0 ? _ref6 : "-001" }), /*#__PURE__*/ React.createElement("div", { className: "w-full items-center flex flex-col" }, /*#__PURE__*/ React.createElement("div", { className: "w-full mb-4 space-y-5" }, /*#__PURE__*/ React.createElement(SubmitButton, { size: "md", text: t("express") }), /*#__PURE__*/ React.createElement(AlertErrorBottomContact, null)))); })));
};
export default OTP;
